import { Injectable } from '@angular/core';
import { BackendAccessService } from '../Services/APICalls/backend-access-service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PreviewProformaInvoiceService {
  constructor(private readonly backend: BackendAccessService) {}

  /* istanbul ignore next */
  async getPublicUrl(subPayload: any): Promise<string> {
    if (!subPayload) {
      throw new Error('Missing payload for invoice preview');
    }

    const resp = await firstValueFrom(
      this.backend.signupInvoicePreview(subPayload)
    );
    const publicUrl = resp?.publicUrl ?? null;

    if (!publicUrl) {
      throw new Error('Invoice preview did not return publicUrl');
    }

    return publicUrl;
  }
  /* istanbul ignore next */
  openInvoiceInNewTab(url: string): void {
    if (!url) {
      console.warn('No URL provided to openInvoiceInNewTab');
      return;
    }
    // open a blank tab first to make popup blockers less likely to block navigation
    const newWin = window.open('', '_blank');
    if (newWin) {
      // navigate the new window to the PDF
      newWin.location.href = url;
      newWin.focus();
    } else {
      // fallback: try direct open (may be blocked)
      window.open(url, '_blank');
    }
  }

  /* istanbul ignore next */
  async generateAndOpen(subPayload: any): Promise<string> {
    const url = await this.getPublicUrl(subPayload);
    this.openInvoiceInNewTab(url);
    return url;
  }
}
